import { useQuery } from '@tanstack/react-query';
import { geographyService } from '@/services/geography.service';

const GEO_KEY = 'geography';

/**
 * Hook to search cities with debounced query
 */
export function useCitySearch(query: string, limit: number = 15) {
  return useQuery({
    queryKey: [GEO_KEY, 'cities', query, limit],
    queryFn: () => geographyService.searchCities(query, limit),
    enabled: query.length >= 2,
    staleTime: 5 * 60 * 1000, // 5 min — geo data doesn't change
  });
}

/**
 * Hook to list departements
 */
export function useDepartements(countryId: number = 1) {
  return useQuery({
    queryKey: [GEO_KEY, 'departements', countryId],
    queryFn: () => geographyService.listDepartements(countryId),
    staleTime: 30 * 60 * 1000, // 30 min
  });
}

/**
 * Hook to list regions
 */
export function useRegions(countryId: number = 1) {
  return useQuery({
    queryKey: [GEO_KEY, 'regions', countryId],
    queryFn: () => geographyService.listRegions(countryId),
    staleTime: 30 * 60 * 1000, // 30 min
  });
}

/**
 * Hook to list countries
 */
export function useCountries() {
  return useQuery({
    queryKey: [GEO_KEY, 'countries'],
    queryFn: () => geographyService.listCountries(),
    staleTime: 30 * 60 * 1000, // 30 min
  });
}
